const sections = document.querySelectorAll("section");
const navLinks = document.querySelectorAll(".header__menus a");

window.addEventListener("scroll", () => {
  let current = "";

  sections.forEach(section => {
    const sectionTop = section.offsetTop;
    if (window.scrollY >= sectionTop - 96) {
      current = section.id;
    }
  });

  navLinks.forEach(link => {
    link.classList.remove("active");

    const href = new URL(link.getAttribute("href"), window.location.origin).hash;

    if (href === "#" + current) {
      link.classList.add("active");
    }
  });
});


const serviceLinks = document.querySelectorAll('nav a[href="/#services"]');
const serviceItems = document.querySelectorAll('.service__item');

serviceLinks.forEach((link, index) => {
  link.addEventListener('click', () => {
    serviceItems.forEach(item => item.classList.remove('selected'));

    if (serviceItems[index]) {
      serviceItems[index].classList.add('selected');
    }
  });
});
